const LANGUAGES = [
  { label: "Abkhazian", value: "AB" },
  { label: "Afar", value: "AA" },
  { label: "Afrikaans", value: "AF" },
  { label: "Akan", value: "AK" },
  { label: "Albanian", value: "SQ" },
  { label: "Amharic", value: "AM" },
  { label: "Arabic", value: "AR" },
  { label: "Aragonese", value: "AN" },
  { label: "Armenian", value: "HY" },
  { label: "Assamese", value: "AS" },
  { label: "Avaric", value: "AV" },
  { label: "Avestan", value: "AE" },
  { label: "Aymara", value: "AY" },
  { label: "Azerbaijani", value: "AZ" },
  { label: "Bambara", value: "BM" },
  { label: "Bashkir", value: "BA" },
  { label: "Basque", value: "EU" },
  { label: "Belarusian", value: "BE" },
  { label: "Bengali", value: "BN" },
  { label: "Bislama", value: "BI" },
  { label: "Bosnian", value: "BS" },
  { label: "Breton", value: "BR" },
  { label: "Bulgarian", value: "BG" },
  { label: "Burmese", value: "MY" },
  { label: "Catalan, Valencian", value: "CA" },
  { label: "Chamorro", value: "CH" },
  { label: "Chechen", value: "CE" },
  { label: "Chichewa, Chewa, Nyanja", value: "NY" },
  { label: "Chinese", value: "ZH" },
  { label: "Church Slavonic, Old Slavonic, Old Church Slavonic", value: "CU" },
  { label: "Chuvash", value: "CV" },
  { label: "Cornish", value: "KW" },
  { label: "Corsican", value: "CO" },
  { label: "Cree", value: "CR" },
  { label: "Croatian", value: "HR" },
  { label: "Czech", value: "CS" },
  { label: "Danish", value: "DA" },
  { label: "Divehi, Dhivehi, Maldivian", value: "DV" },
  { label: "Dutch, Flemish", value: "NL" },
  { label: "Dzongkha", value: "DZ" },
  { label: "English", value: "EN" },
  { label: "Esperanto", value: "EO" },
  { label: "Estonian", value: "ET" },
  { label: "Ewe", value: "EE" },
  { label: "Faroese", value: "FO" },
  { label: "Fijian", value: "FJ" },
  { label: "Finnish", value: "FI" },
  { label: "French", value: "FR" },
  { label: "Western Frisian", value: "FY" },
  { label: "Fulah", value: "FF" },
  { label: "Gaelic, Scottish Gaelic", value: "GD" },
  { label: "Galician", value: "GL" },
  { label: "Ganda", value: "LG" },
  { label: "Georgian", value: "KA" },
  { label: "German", value: "DE" },
  { label: "Greek, Modern (1453–)", value: "EL" },
  { label: "Kalaallisut, Greenlandic", value: "KL" },
  { label: "Guarani", value: "GN" },
  { label: "Gujarati", value: "GU" },
  { label: "Haitian, Haitian Creole", value: "HT" },
  { label: "Hausa", value: "HA" },
  { label: "Hebrew", value: "HE" },
  { label: "Herero", value: "HZ" },
  { label: "Hindi", value: "HI" },
  { label: "Hiri Motu", value: "HO" },
  { label: "Hungarian", value: "HU" },
  { label: "Icelandic", value: "IS" },
  { label: "Ido", value: "IO" },
  { label: "Igbo", value: "IG" },
  { label: "Indonesian", value: "ID" },
  {
    label: "Interlingua (International Auxiliary Language Association)",
    value: "IA",
  },
  { label: "Interlingue, Occidental", value: "IE" },
  { label: "Inuktitut", value: "IU" },
  { label: "Inupiaq", value: "IK" },
  { label: "Irish", value: "GA" },
  { label: "Italian", value: "IT" },
  { label: "Japanese", value: "JA" },
  { label: "Javanese", value: "JV" },
  { label: "Kannada", value: "KN" },
  { label: "Kanuri", value: "KR" },
  { label: "Kashmiri", value: "KS" },
  { label: "Kazakh", value: "KK" },
  { label: "Central Khmer", value: "KM" },
  { label: "Kikuyu, Gikuyu", value: "KI" },
  { label: "Kinyarwanda", value: "RW" },
  { label: "Kirghiz, Kyrgyz", value: "KY" },
  { label: "Komi", value: "KV" },
  { label: "Kongo", value: "KG" },
  { label: "Korean", value: "KO" },
  { label: "Kuanyama, Kwanyama", value: "KJ" },
  { label: "Kurdish", value: "KU" },
  { label: "Lao", value: "LO" },
  { label: "Latin", value: "LA" },
  { label: "Latvian", value: "LV" },
  { label: "Limburgan, Limburger, Limburgish", value: "LI" },
  { label: "Lingala", value: "LN" },
  { label: "Lithuanian", value: "LT" },
  { label: "Luba-Katanga", value: "LU" },
  { label: "Luxembourgish, Letzeburgesch", value: "LB" },
  { label: "Macedonian", value: "MK" },
  { label: "Malagasy", value: "MG" },
  { label: "Malay", value: "MS" },
  { label: "Malayalam", value: "ML" },
  { label: "Maltese", value: "MT" },
  { label: "Manx", value: "GV" },
  { label: "Maori", value: "MI" },
  { label: "Marathi", value: "MR" },
  { label: "Marshallese", value: "MH" },
  { label: "Mongolian", value: "MN" },
  { label: "Nauru", value: "NA" },
  { label: "Navajo, Navaho", value: "NV" },
  { label: "North Ndebele", value: "ND" },
  { label: "South Ndebele", value: "NR" },
  { label: "Ndonga", value: "NG" },
  { label: "Nepali", value: "NE" },
  { label: "Norwegian", value: "NO" },
  { label: "Norwegian Bokmål", value: "NB" },
  { label: "Norwegian Nynorsk", value: "NN" },
  { label: "Sichuan Yi, Nuosu", value: "II" },
  { label: "Occitan", value: "OC" },
  { label: "Ojibwa", value: "OJ" },
  { label: "Oriya", value: "OR" },
  { label: "Oromo", value: "OM" },
  { label: "Ossetian, Ossetic", value: "OS" },
  { label: "Pali", value: "PI" },
  { label: "Pashto, Pushto", value: "PS" },
  { label: "Persian", value: "FA" },
  { label: "Polish", value: "PL" },
  { label: "Portuguese", value: "PT" },
  { label: "Punjabi, Panjabi", value: "PA" },
  { label: "Quechua", value: "QU" },
  { label: "Romanian, Moldavian, Moldovan", value: "RO" },
  { label: "Romansh", value: "RM" },
  { label: "Rundi", value: "RN" },
  { label: "Russian", value: "RU" },
  { label: "Northern Sami", value: "SE" },
  { label: "Samoan", value: "SM" },
  { label: "Sango", value: "SG" },
  { label: "Sanskrit", value: "SA" },
  { label: "Sardinian", value: "SC" },
  { label: "Serbian", value: "SR" },
  { label: "Shona", value: "SN" },
  { label: "Sindhi", value: "SD" },
  { label: "Sinhala, Sinhalese", value: "SI" },
  { label: "Slovak", value: "SK" },
  { label: "Slovenian", value: "SL" },
  { label: "Somali", value: "SO" },
  { label: "Southern Sotho", value: "ST" },
  { label: "Spanish, Castilian", value: "ES" },
  { label: "Sundanese", value: "SU" },
  { label: "Swahili", value: "SW" },
  { label: "Swati", value: "SS" },
  { label: "Swedish", value: "SV" },
  { label: "Tagalog", value: "TL" },
  { label: "Tahitian", value: "TY" },
  { label: "Tajik", value: "TG" },
  { label: "Tamil", value: "TA" },
  { label: "Tatar", value: "TT" },
  { label: "Telugu", value: "TE" },
  { label: "Thai", value: "TH" },
  { label: "Tibetan", value: "BO" },
  { label: "Tigrinya", value: "TI" },
  { label: "Tonga (Tonga Islands)", value: "TO" },
  { label: "Tsonga", value: "TS" },
  { label: "Tswana", value: "TN" },
  { label: "Turkish", value: "TR" },
  { label: "Turkmen", value: "TK" },
  { label: "Twi", value: "TW" },
  { label: "Uighur, Uyghur", value: "UG" },
  { label: "Ukrainian", value: "UK" },
  { label: "Urdu", value: "UR" },
  { label: "Uzbek", value: "UZ" },
  { label: "Venda", value: "VE" },
  { label: "Vietnamese", value: "VI" },
  { label: "Volapük", value: "VO" },
  { label: "Walloon", value: "WA" },
  { label: "Welsh", value: "CY" },
  { label: "Wolof", value: "WO" },
  { label: "Xhosa", value: "XH" },
  { label: "Yiddish", value: "YI" },
  { label: "Yoruba", value: "YO" },
  { label: "Zhuang, Chuang", value: "ZA" },
  { label: "Zulu", value: "ZU" },
];

export default LANGUAGES;
